export default __webpack_public_path__ + "static/media/work-10.018a83e3.jpg";